/**
 * Type redeclaration around `useParams` from `react-router-dom` that
 * makes its return type more like that of v5's `useParams`, albeit
 * at the cost of truthfulness.
 *
 * Specifically, v5's useParams typed all parameters as truthy, which
 * is not correct but nevertheless what our codebase's types expect.
 *
 * TODO: update call sites to handle undefined param values.
 */

import { getRouterAdapter } from '../utils';

/**
 * Type redeclaration around `useParams` from `react-router-dom` that
 * makes its return type more like that of v5's `useParams`.
 *
 * @deprecated use `useParams` instead.
 */
export const useParamsLegacy = <Params extends object = {}>() =>
  getRouterAdapter().useParams() as unknown as Params;
